<template>
  <div>
    <app-title>Personalise</app-title>
    <v-card>
      <v-card-text>
        <v-row  >
          <v-list xs4 box>
            <div v-for="(item, index) in items" :key="index">
              <v-list-group :prepend-icon="item.icon" value="true">
                <v-list-tile slot="activator">
                  <v-list-tile-title>{{item.title}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-for="(admin, i) in item.subMenu" :key="i">
                  <v-list-tile-title v-text="admin[0]"></v-list-tile-title>
                  <v-list-tile-action>
                    <v-icon v-text="admin[1]"></v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-group>
            </div>
          </v-list>
        </v-row>
        <v-row  >
          <div class="text-center" xs4>
            <v-menu offset-y>
              <v-btn slot="activator" color="primary" dark>Dropdown</v-btn>
              <v-list>
                <v-list-tile v-for="(item, index) in items[0].subMenu" :key="index" >
                  <v-list-tile-title>{{ item[0] }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import items from "@/components/menuItems";
export default {
  name: "app-sidebar",
  props: ["drawer"],
  data() {
    return {
      clipped: true,
      fixed: false,
      right: true,
      rightDrawer: false,
      title: "Vonex",
      enabledClass: "enabled",
      disabledClass: "disabled",
      items: items.items.filter(x => x.hasOwnProperty("subMenu")),
      miniVariant: false,
      admins: [["Management", "people_outline"], ["Settings", "settings"]]
    };
  },

  computed: {
    hideDrawer: function() {
      return this.drawer;
    }
  },
  methods: {
    navigate: function(route) {
      this.$router.push(route);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.expand {
  height: auto !important;
  display: block !important;
}

.new-collapse {
  display: none !important;
}
</style>
